module.exports = __webpack_public_path__ + "d8f4a434ef089746f93cf47c52debd84.svg";